import { Number as IntlNumber, Currency } from "react-intl-number-format";

function TotalDistance ( { distance, funds } ) 
{
    return  <div className="mb-4 p-4 rounded-2xl bg-pgsurface flex flex-col xs:flex-row gap-8 xs:justify-between">
                <div>
                    <div className="flex flex-row justify-between">
                        <div className="text-xs sm:text-md text-pgdarkteal">TOTAL KM SO FAR</div>
                    </div>
                    <div className="flex flex-row justify-between">
                        <div className="font-bold text-4xl sm:text-5xl text-pgdarkteal"><IntlNumber>{Number ( distance ).toFixed ( 0 )}</IntlNumber></div>
                    </div>
                </div>
                <div className="flex flex-col xs:items-end">
                    <div className="flex flex-row justify-between">
                        <div className="text-xs sm:text-md text-pgdarkteal">TOTAL FUNDS RAISED</div>
                    </div>
                    <div className="flex flex-row justify-between">
                        <div className="font-bold text-4xl sm:text-5xl text-pgdarkteal"><Currency currency="GBP" maximumFractionDigits={0}>{Number ( funds ).toFixed ( 0 )}</Currency></div>
                    </div>
                </div>
            </div>
}

export default TotalDistance;
